import { io } from "socket.io-client"

const connection_local =  "192.168.0.2:3016"

const connection_producion = "https://www.socket.pedidosedificor.com.ar"

const socket = io(connection_producion, { forceNew: true } )
 
export default socket
